import T from 'T'

export const LATE_FEE_REVIEW_TABS = {
  READY_FOR_INVOICE: T.READY_FOR_INVOICE,
  INVOICED: T.INVOICED,
  WAIVED: T.WAIVED,
  ALL_ASSESSED: T.ALL_ASSESSED,
}
